import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import { T2, B1, Text32 } from '@nile/components';

const SIZE_MAP = {
  secondary: {
    height: '80px',
    width: '100px'
  }
};

const NoDataContent = styled.div`
  display: flex;
  .text {
    line-height: 60px;
  }
  .description {
    max-width: 400px;
    padding-right: 80px;
  }
`;

export const Image = styled.div.attrs({
  className: 'ignoreOverride'
})`
  background-image: ${(props) => props.url};
  background-size: 100%;
  background-repeat: no-repeat;
  height: ${(props) => props.height || '170px'};
  width: ${(props) => props.width || '200px'};
`;

const NodataCardContent = styled.div.attrs({
  className: 'flex center col noDataWrapper'
})`
  width: ${(props) => props.wrapperWidth ?? '300px'};
  .text {
    font-size: 20px;
    line-height: 28px;
  }
  .secondary .text {
    font-size: 20px;
    line-height: 30px;
  }
  .description {
    font-size: 14px;
    line-height: 24px;
    white-space: normal;
    text-align: center;
  }
  .secondary .description {
    font-size: 14px;
    line-height: 21px;
  }
`;

function NoData(props) {
  const { imageURL, text, description, height, width } = props;
  return (
    <NoDataContent>
      <div className="flex col mr-20">
        {text && (
          <Text32 className="text">
            <B1>{text}</B1>
          </Text32>
        )}
        {description && <T2 className="description">{description}</T2>}
      </div>
      <Image url={imageURL} height={height} width={width} />
    </NoDataContent>
  );
}

function NoDataCard(props) {
  const {
    imageURL,
    text,
    description,
    height = '120px',
    width = '120px',
    type,
    darkTheme,
    wrapperWidth
  } = props;
  const classNames = `${type || ''} flex col mt20 center jcenter`;
  const computedHeight = SIZE_MAP[type]?.height || height;
  const computedWidth = SIZE_MAP[type]?.width || width;
  return (
    <>
      <NodataCardContent wrapperWidth={wrapperWidth}>
        <Image
          className="noDataImage"
          url={imageURL}
          height={computedHeight}
          width={computedWidth}
        />
        <div className={classNames}>
          {text && (
            <div className={`text mb10 ${darkTheme ? 'textDark' : ''}`}>
              <B1>{text}</B1>
            </div>
          )}
          {description && (
            <T2 className={`${darkTheme ? 'textDark' : ''} description`}>
              {description}
            </T2>
          )}
        </div>
      </NodataCardContent>
    </>
  );
}

export { NoData, NoDataCard };
